// Copies text to the clipboard. Uses the async Clipboard API when available and
// falls back to a temporary <textarea> + execCommand for older or insecure
// (non-HTTPS) contexts where that API is missing or blocked.
export function copyToClipboard(text) {
    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text).catch(() => copyWithTextarea(text))
    }

    copyWithTextarea(text)
}

function copyWithTextarea(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()

    try {
        document.execCommand('copy')
    } catch {
        // Clipboard unavailable — nothing more we can do.
    }

    document.body.removeChild(textarea)
}
